import 'css-chunksrc/client/pages/projectPage/exportsPage/wbsReport/styles.scss';export default {
  "wbsReport": "_wbsReport_lcxp7_1",
  "checked": "_checked_lcxp7_7",
  "row": "_row_lcxp7_11",
  "checkbox": "_checkbox_lcxp7_20",
  "col": "_col_lcxp7_26",
  "name": "_name_lcxp7_30",
  "description": "_description_lcxp7_37",
  "filters": "_filters_lcxp7_42",
  "button": "_button_lcxp7_51"
};